import { EventAggregator } from 'aurelia-event-aggregator';
import { inject, autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Redirect } from 'aurelia-router';
import { Features } from '../models/features';
import { FeatureService } from '../services/feature-service';
import { State } from '../services/global-state';
import { SessionManager } from "../services/session-manager";
import { HTTPInjector } from "../services/http-injector";
import { AuthorizationRedirectManager } from '../helpers/authorization-redirect-manager';

// Note: this is the same event from aurelia i18next
export const I18N_EA_SIGNAL = "i18n:locale:changed";

@autoinject
export class App {
	updateTranslationsSubscriber: any;

	constructor(
        public httpInjector: HTTPInjector, //Load the injector to be used app wide
        private globalState: State,
        private featureService: FeatureService,
		private eventAggregator: EventAggregator,
        private i18n: I18N,
        private element: Element
    ) {
		let self = this;

        this.updateTranslationsSubscriber = this.eventAggregator.subscribe(I18N_EA_SIGNAL, () => {
			self.i18n.updateTranslations(self.element);
		});
	}

	activate() {
		return this.featureService.getFeatures().then(response => {
			try {
				if (response.isSuccessful) {
					this.globalState.features = new Features(response.entity);
					console.log('Features loaded.');
				} else {
					console.log('getFeatures failed to retrieve features.')
				}
			}
			catch (err) {
				console.log('Error occurred while assigning features.');
			}
		}).catch(error => {
			console.log('getFeatures failed.', error);
		});

	}

	configureRouter(config, router) {
		config.title = 'myPayrazr portal';
		config.options.pushState = true;
		config.options.root = '/NewPortalWeb/';
		config.addPipelineStep('authorize', TimeoutStep);
		config.map([
			{ route: ['portal/:id', 'm/:id'], name: 'portal', moduleId: './portal' },
			{ route: '401', name: '401', moduleId: './http-status/401', title: 'Session expired' },
			{ route: 'inactive', name: 'inactive', moduleId: './login-register/inactive', title: 'Inactive Portal' },
			{ route: 'error', name: 'error', moduleId: './error/error', title: 'An Error Occurred' },
			{ route: 'terms', name: 'terms', moduleId: './legal/terms', title: 'Website terms of use' },
			{ route: 'disclosures', name: 'disclosures', moduleId: './legal/disclosures', title: 'Website legal disclosures' },
			{ route: 'privacy-policy', name: 'privacy-policy', moduleId: './legal/privacy-policy', title: 'Privacy Policy' }
		]);

		config.mapUnknownRoutes('./http-status/404');

	}
}

@autoinject
class TimeoutStep {

	constructor(private sessionManager: SessionManager, private authRedirectManager: AuthorizationRedirectManager,
		private globalState: State) {
	}

	run(navigationInstruction: any, next: any) {
		let timedOut = !this.sessionManager.sessionTimer;

		if (timedOut) {
			next.cancel(new Redirect('401'));
		}

		// only secure routes require auth check
		let isAuthRequired: boolean = navigationInstruction.getAllInstructions().some(i => i.config.settings?.auth ?? false);
		if (!isAuthRequired) {
			return next();
		}
		// check to make sure token has consumerUserId before accessing secure pages
		if (!this.sessionManager.isAuthenticated()) {
			return next.cancel(new Redirect(this.authRedirectManager.handleNotAuthorized(navigationInstruction)));
		}
		// if populated, redirectUri will be the original destination uri before auth failed
		let redirectUri = this.authRedirectManager.getPreAuthUri();
		if (redirectUri) {
			return next.cancel(new Redirect(redirectUri));
		}

		return next();

		return next();
	}
}
